import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const RefreshCircle: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.29956 4.9365L8.00022 5.63717L7.21289 4.84983L8.00022 4.0625"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      // eslint-disable-next-line max-len
      d="M5.4889 6.11872C5.09423 6.64472 4.85156 7.29138 4.85156 8.00005C4.85156 9.73872 6.2609 11.1481 7.99956 11.1481C9.73823 11.1481 11.1476 9.73872 11.1476 8.00005C11.1476 6.26138 9.73823 4.85205 7.99956 4.85205C7.75756 4.85205 7.5249 4.88472 7.2989 4.93672"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      // eslint-disable-next-line max-len
      d="M12.2426 3.75736C14.5858 6.10051 14.5858 9.89949 12.2426 12.2426C9.89948 14.5858 6.10049 14.5858 3.75736 12.2426C1.41421 9.89948 1.41421 6.10049 3.75736 3.75736C6.10051 1.41421 9.89949 1.41421 12.2426 3.75736"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
